import React from 'react';
import { NavLink } from 'react-router-dom';
import LoginModal from '../components/LoginModal';
export default class StyledNavbar extends React.Component {

  render() {
    return (
      <div className='container p-0 d-print-none'>
      <nav className="navbar navbar-expand-md navbar-light bg-light">
      <div className="container-fluid">
        <NavLink className="navbar-brand" to="/" >Ideal Training Academy</NavLink>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse ml-auto w-100" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-md-0">
            <li className="nav-item">
             <NavLink to="/" className="nav-link active" aria-current="page" >Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/ReportPrint" className="nav-link" >SBA Card</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className="nav-link" >About Us</NavLink>
            </li>
            <li className="nav-item">
            <NavLink to="/contact" className="nav-link" >Contact Us</NavLink>
          </li>
        
          </ul>
     <LoginModal/>
        </div>
      </div>
    </nav>
      </div>
    );
  }
}